var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.client)?_c('b-form-checkbox',{staticClass:"m-t-15",attrs:{"value":1,"unchecked-value":0},model:{value:(_vm.generar_current_acount),callback:function ($$v) {_vm.generar_current_acount=$$v},expression:"generar_current_acount"}},[_vm._v(" Generar movimiento en C/C ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }